import { useState, useCallback, useEffect } from 'react';
import { useSelf } from '@utils/react';

let SortCoursesBy = /*#__PURE__*/function (SortCoursesBy) {
  SortCoursesBy[SortCoursesBy["TITLE"] = 0] = "TITLE";
  SortCoursesBy[SortCoursesBy["MODIFIED_AT"] = 1] = "MODIFIED_AT";
  SortCoursesBy[SortCoursesBy["LEVEL"] = 2] = "LEVEL";
  SortCoursesBy[SortCoursesBy["SUBJECT"] = 3] = "SUBJECT";
  return SortCoursesBy;
}({});
const DEFAULT_SORT_DIRECTION = "asc";
function useSortedCourses(courses, filterOptions) {
  const options = useSelf({
    sortBy: SortCoursesBy.MODIFIED_AT,
    direction: "desc",
    ...filterOptions
  });
  const [sortedCourses, setSortedCourses] = useState(sort(courses, options));
  const applySort = useCallback(newSort => {
    // In case courses should be sorted by the same key once again then simply
    // flip the direction in which it is sorted
    if (newSort === options.sortBy) {
      options.direction = options.direction === "asc" ? "desc" : "asc";
    } else {
      // ... otherwise, reset direction and apply the new sort
      options.direction = DEFAULT_SORT_DIRECTION;
      options.sortBy = newSort;
    }
    setSortedCourses(sort(courses, options));
  }, [courses, options]);

  // Ensure that a new sort is applied every time the filtered list of courses
  // is changed externally.
  useEffect(() => {
    options.query = filterOptions.query;
    options.section = filterOptions.section;
    setSortedCourses(sort(courses, options));
  }, [courses, options, filterOptions]);
  return [sortedCourses, applySort, options];
}
function sort(courses, options) {
  return [...courses].sort((a, b) => {
    let result = 0;
    switch (options.sortBy) {
      case SortCoursesBy.TITLE:
        result = (a.title ?? "").localeCompare(b.title ?? "");
        break;
      case SortCoursesBy.MODIFIED_AT:
        result = a.modifiedAt.getTime() - b.modifiedAt.getTime();
        break;
      case SortCoursesBy.SUBJECT:
        result = a.subjects.join(",").localeCompare(b.subjects.join(","));
        break;
      case SortCoursesBy.LEVEL:
        result = b.levels.join(",").localeCompare(a.levels.join(","));
        break;
    }
    return options.direction === "asc" ? result : result * -1;
  });
}

export { DEFAULT_SORT_DIRECTION, SortCoursesBy, useSortedCourses };
//# sourceMappingURL=sorted-courses.js.map
